import { render, staticRenderFns } from "./VariablesList.vue?vue&type=template&id=c67af884"
import script from "./VariablesList.vue?vue&type=script&lang=js"
export * from "./VariablesList.vue?vue&type=script&lang=js"
import style0 from "./VariablesList.vue?vue&type=style&index=0&id=c67af884&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports